module.exports = __webpack_public_path__ + "static/media/faqCatgry_attach.cf817093.svg";